
const userStore: {[name: string]: any} = {};

export const UserConfig = {
  get: (key: string): any => {
    return userStore[key];
  },
  set: (key: string, value: any): void => {
    userStore[key] = value;
  },
  delete: (key: string): void => {
    delete userStore[key];
  },
};
